export default import.meta.ROLLUP_FILE_URL_fY4sx$ZNJbVg3C8gMfgFIA